import { render, staticRenderFns } from "./PointsIcon.vue?vue&type=template&id=9b655622&"
import script from "./PointsIcon.vue?vue&type=script&lang=js&"
export * from "./PointsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports